import { focusEmulatorSurface } from './gamepad.js';

/** Abre a barra de menu do EmulatorJS (equivalente ao ESC / hamburger em touch). */
export function openEmulatorMenu() {
  const emu = window.EJS_emulator;
  if (!emu?.started || !emu.menu?.open) return false;
  focusEmulatorSurface();
  emu.menu.open(true);
  return true;
}

/** Abre directamente o popup de configuração de controlos. */
export function openEmulatorControlSettings() {
  const emu = window.EJS_emulator;
  if (!emu?.started || !emu.controlMenu) return false;
  focusEmulatorSurface();
  if (emu.menu?.open) emu.menu.open(true);
  emu.controlMenu.style.display = '';
  return true;
}

/** Menu principal ou fallback para controlos (tablet sem ESC). */
export function openEmulatorMenuOrControls() {
  return openEmulatorMenu() || openEmulatorControlSettings();
}

/** DS / desmume: core carrega mas o jogo só arranca após gesto (Play). */
export function isEmulatorWaitingToStart() {
  const emu = window.EJS_emulator;
  return !!(emu && !emu.started);
}

/** Equivalente ao botão Play do EmulatorJS (necessário em touch / tablet). */
export function startEmulatorGame() {
  const emu = window.EJS_emulator;
  if (!emu || emu.started) return false;
  focusEmulatorSurface();
  const fakeEvent = {
    pointerType: 'touch',
    preventDefault: () => {},
    target: { remove: () => {} },
  };
  if (typeof emu.startButtonClicked === 'function') {
    emu.startButtonClicked(fakeEvent);
    return true;
  }
  if (typeof emu.startGame === 'function') {
    emu.startGame();
    return true;
  }
  return false;
}
